import { CommonModule } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCommonModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { ActivatedRoute } from "@angular/router";
import { take } from "rxjs/operators";
import { IContactInformation } from "src/app/iap/models/contactInformation.model";
import { ContactInformationService } from "src/app/iap/services/contact-information.service";
import { MyProfileService } from "src/app/iap/services/my-profile.service";
import { AuthenticationService } from "src/app/shared/auth/auth.service";
import { Helper } from "src/app/shared/common/helper";
import { LookupsService } from "src/app/shared/services/lookups.service";
import { v4 as uuidv4 } from "uuid";
import { Location } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { environment } from "src/environments/environment";
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CustomToasterComponent } from "src/app/shared/components/custom-toaster/custom-toaster.component";


@Component({
    selector: "app-onboarding-contact-information",
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatCommonModule,
        MatRadioModule,
        MatCardModule,
        MatIconModule,
        MatSnackBarModule
    ],
    templateUrl: "./onboarding-contact-information.component.html",
    styleUrl: "./onboarding-contact-information.component.scss"
})
export class OnboardingContactInformationComponent implements OnChanges, OnDestroy {
  @Input() formId: number; // Unique ID for this form instance
  @Input() formIndex: number; // Index in the contactInfoForms array
  @Input() contactInfoData: IContactInformation; //agent's contact info for prefilling form
  @Input() agencyId: number; //agency id
  @Input() agentId: string; //agent id
  @Input() contactInfoStatus: string; //contact info status
  @Output() saveContactInfo = new EventEmitter<{
    formId: number;
    formIndex: number;
    contactFormData;
    file;
  }>(); //to contact-information - sends output to be saved and closes form
  @Output() cancelOutput = new EventEmitter(); //to contact-information - closes form

  countries: any = []; //array of countries
  titles = ["Mr.", "Miss.", "Ms.", "Mrs."]; //array of titles
  hasImg = false;
  isSaved = false;
  showFillTestDataButton: boolean = false; //show button only in dev mode
  // agentId: string = "";
  // agencyId: string = "";

  //form template
  contactInfoForm: FormGroup = this._formBuilder.group({
    salutation: ["", Validators.required],
    firstName: ["", [Validators.required, Validators.pattern(/^[A-Za-z]+(?:[ '-][A-Za-z]+)*$/)]],
    lastName: ["", [Validators.required, Validators.pattern(/^[A-Za-z]+(?:[ '-][A-Za-z]+)*$/)]],
    jobTitle: ["", [Validators.required, Validators.pattern(/^[A-Za-z0-9\s&.,'()\/\-]+$/)]],
    provinceOrState: [""],
    country: ["", Validators.required],
    city: ["", [Validators.required, Validators.pattern(/(.|\s)*\S(.|\s)*/)]],
    addressOne: ["", [Validators.required, Validators.pattern(/(.|\s)*\S(.|\s)*/)]],
    addressTwo: [""],
    postalCode: [""],
    countryCode1: ["", [Validators.required, Validators.pattern(/^\+?[0-9]{1,3}$/)]],
    primaryPhone: ["", [Validators.required, Validators.minLength(7), Validators.pattern(/^[0-9]{7,12}$/)]],
    countryCode2: ["", Validators.pattern(/^(\+[0-9]{1,3}|[0-9]{0,3})$/)],
    secondaryPhone: ["", Validators.pattern(/^[0-9]{7,12}$/)],
    email: ["", [Validators.required, Validators.email, Validators.maxLength(150)]],
    agentId: [""], //hidden field, records agent's id
    agencyID: [""], //hidden field, records agency's id
    imgFileName: [""], //hidden field, records the contacts image filename
    delImgFileName: [""], //hidden field, records name of the file to be deleted (if there is one)
    newImgFileName: [""], //hidden field, records the name of the uploaded file (if there is one)
    imgUploaded: [false], //hidden field, records whether an image was uploaded
    imgDeleted: [false], //hidden field, records whether an image was deleted
    userType: ["", Validators.required],
  });

  @ViewChild("imgUpload") imgUpload: ElementRef; //imgupload element

  newImg: File = null;
  user: any;
  isSaving: boolean = false; //prevent duplicate saves
  private destroy$ = new Subject<void>();
  private lastSavedState: any = null; //track last saved state to prevent duplicates

  constructor(
    private location: Location,
    private _formBuilder: FormBuilder,
    private contactInfoService: ContactInformationService,
    private lookupService: LookupsService,
    private route: ActivatedRoute,
    private myProfileService: MyProfileService,
    private authService: AuthenticationService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    console.log("The agentID is: ", this.agentId);
    console.log("The agencyID is: ", this.agencyId);
    console.log("Contact Info Status: ", this.contactInfoStatus);
    this.user = this.authService.getUserInfo();
    console.log("User: ", this.user);
    // Set button visibility based on environment
    this.showFillTestDataButton = environment.showTestButton;
    //console.log("showFillTestDataButton:", this.showFillTestDataButton, "production:", environment.production);
    // this.contactInfoService.getContactInfoById(this.user.oid)
    //  .subscribe(agencyInfo => {
    //   console.log("Agency Info: ", agencyInfo);
    //   this.agencyId = agencyInfo.agencyId;
    //   console.log("Agency Id: ", this.agencyId); // Moved inside the subscription
    //  });
    if (this.user && this.user.oid) {
      // this.loadAgencyInfo();
    } else {
      console.error("User OID is not set");
    }
    this.loadCountries();
    // await this.waitForContactInfoStatusUpdate();
    // await this.getContactInfo();
    // this.hasImg = this.contactInfoData.ImgFileName != "" ? true : false;
    this.createForm();
    // Load any saved draft from session storage
    this.loadDraft();
    // Set agentId and agencyId after createForm (overwrites if draft also set these)
    this.contactInfoForm.patchValue({
      agentId: this.agentId,
      agencyID: this.agencyId,
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['agentId'] && this.contactInfoForm) {
      console.log("agentId changed to: ", this.agentId);
      this.contactInfoForm.patchValue({
        agentId: this.agentId
      });
    }
    // Load draft if formIndex input changes or on first change
    if (changes['formIndex'] && this.contactInfoForm) {
      this.loadDraft();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Load draft data from sessionStorage for this form instance.
   */
  private loadDraft(): void {
    const draftKey = 'onboarding_contact_draft_' + (this.formIndex != null ? this.formIndex : 0);
    const draft = sessionStorage.getItem(draftKey);
    if (draft) {
      try {
        this.contactInfoForm.patchValue(JSON.parse(draft));
      } catch (e) {
        console.error('Failed to parse onboarding contact draft', e);
      }
    }
  }


  // save() {
  //   console.log("The form value is: ", this.contactInfoForm.value);
  //   console.log(this.newImg);
  //   if(this.contactInfoForm.valid){
  //     console.log("Inside the if statement");
  //     this.contactInfoService.updateContactInfo(this.contactInfoForm.value, this.newImg).subscribe(response => {
  //       console.log("Contact Information Updated: ", response);
  //     });

  //     // Assuming that the row already exists for the agency ID in Agency onbaording status table.
  //     console.log("Updating agency onboarding status for agency ID: ", this.agencyId);
  //     // this.myProfileService.updateAgencyInformation(this.contactInfoForm.value, this.agencyId).subscribe(response => {
  //     //   console.log("Contact Information Updated: ", response);
  //     // });

  //     // let the user know that the form was saved
  //     // this.saveOutput.emit();
  //     this.isSaved = true;
  //   }
  // }

  save() {
    if (this.isSaving) {
      console.warn("Save already in progress, ignoring duplicate request");
      return;
    }

    if (!this.contactInfoForm.valid) {
      this.contactInfoForm.markAllAsTouched();
      console.log("Form is NOT VALID");
      return;
    }

    this.isSaving = true;
    const formData = this.contactInfoForm.value;
    const file = this.newImg;

    // Create a state object for this save operation
    const saveState = {
      formId: this.formId,
      formIndex: this.formIndex,
      contactFormData: formData,
      file: file,
      timestamp: Date.now(),
    };

    // Check if this is a duplicate save (same data being saved again)
    if (this.lastSavedState && JSON.stringify(this.lastSavedState) === JSON.stringify(saveState)) {
      console.warn("Duplicate save detected, ignoring");
      this.isSaving = false;
      return;
    }

    try {
      // Store the state before emitting
      this.lastSavedState = { ...saveState };

      console.log("Saving contact information:", saveState);
      
      // Emit the save event with all data
      this.saveContactInfo.emit(saveState);

      // Persist draft to sessionStorage using a unique key per form instance
      const draftKey = 'onboarding_contact_draft_' + (this.formIndex != null ? this.formIndex : 0);
      sessionStorage.setItem(draftKey, JSON.stringify(this.contactInfoForm.getRawValue()));
      
      // Reset the saving flag after a short delay to allow parent to process
      setTimeout(() => {
        this.isSaving = false;
      }, 100);

      // Show success message
      this.snackBar.openFromComponent(CustomToasterComponent, {
        data: { title: 'SUCCESS', message: 'Contact information saved successfully!', type: 'success' },
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['custom-toast-panel']
      });
    } catch (error) {
      console.error("Error during save:", error);
      this.isSaving = false;
      this.lastSavedState = null; //reset state on error
      this.snackBar.openFromComponent(CustomToasterComponent, {
        data: { title: 'ERROR', message: 'Error saving contact information. Please try again.', type: 'error' },
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['custom-toast-panel']
      });
    }
  }

  cancel() {
    this.cancelOutput.emit();
  }

  private waitForContactInfoStatusUpdate(): Promise<void> {
    return new Promise((resolve) => {
      const checkStatus = () => {
        if (this.contactInfoStatus !== undefined) {
          resolve();
        } else {
          setTimeout(checkStatus, 100); // Check every 100ms
        }
      };
      checkStatus();
    });
  }

  async getContactInfo() {
    console.log(
      "User OID in the contact information component in getContactInfo: ",
      this.user.oid
    );
    console.log("Contact Info Status: ", this.contactInfoStatus);
    if (this.contactInfoStatus === "True") {
      try {
        const contactInfo: IContactInformation = await this.contactInfoService
          .getContactInfoById(this.user.oid)
          .toPromise();
        console.log("Contact Info: ", contactInfo);
        this.contactInfoData = contactInfo;
        console.log("Contact Info Data: ", this.contactInfoData);
      } catch (error) {
        console.error(error);
      }
    }

    // return new Promise<void>((resolve, reject) => {
    // this.contactInfoService
    //   .getContactInfoById(this.user.oid)
    //   .subscribe((contactInfo: IContactInformation) => {
    //       console.log("Contact Info: ", contactInfo);
    //       this.contactInfoData = contactInfo;
    //       console.log("Contact Info Data: ", this.contactInfoData);
    //       resolve();
    //     }, error => {
    //       reject(error);
    //     });
    // });
  }

  private createForm() {
    console.log(      "Contact Info Data in the contact information component: ", this.contactInfoData);
    console.log(      "Agent ID in the contact information component: ", this.agentId );
    //bind values to the form
    // NOTE: Removed country field - will be set after countries are loaded
    this.contactInfoForm.patchValue({
      salutation: this.contactInfoData?.Title || "",
      firstName: this.contactInfoData?.FName || "",
      lastName: this.contactInfoData?.LName || "",
      jobTitle: this.contactInfoData?.JobTitle || "",
      provinceOrState: this.contactInfoData?.State || "",
      city: this.contactInfoData?.City || "",
      addressOne: this.contactInfoData?.Address1 || "",
      addressTwo: this.contactInfoData?.Address2 || "",
      postalCode: this.contactInfoData?.PostalCode || "",
      countryCode1: this.contactInfoData?.CountryCode1 || "",
      primaryPhone: this.contactInfoData?.Phone1 || "",
      /*primaryPhone:
        this.contactInfoData?.Phone1 && this.contactInfoData?.Phone1 !== ""
          ? `(${this.contactInfoData?.CountryCode1?.trim()})${
              this.contactInfoData?.Phone1
            }`
          : "",*/
          countryCode2: this.contactInfoData?.CountryCode2 || "",
      secondaryPhone: this.contactInfoData?.Phone2 || "",
      /*secondaryPhone:
        this.contactInfoData?.Phone2 && this.contactInfoData?.Phone2 !== ""
          ? `(${this.contactInfoData?.CountryCode2?.trim()})${
              this.contactInfoData?.Phone2
            }`
          : "",*/
      email: this.contactInfoData?.Email || "",
      imgFileName: this.contactInfoData?.ImgFileName || "",
      delImgFileName: "",
      newImgFileName: "",
      imgUploaded: false,
      imgDeleted: false,
      userType: this.contactInfoData?.userType || "",
      agentId: this.agentId || this.contactInfoData?.agentId || "", 
    });
  }

  fillTestData(): void {

    this.contactInfoForm.patchValue({
      salutation: "Mr.",
      firstName: "John",
      lastName: "Smith",
      jobTitle: "Director",
      country: "CAN",
      provinceOrState: "Ontario",
      city: "Toronto",
      addressOne: "123 Education Street",
      addressTwo: "Suite 100",
      postalCode: "M5V 2T6",
      countryCode1: "1",
      primaryPhone: "4165550123",
      countryCode2: "2",
      secondaryPhone: "4165550124",
      email: "agency768@2026inc.com",
      agentId: this.agentId,
      agencyID: this.agencyId,
      imgFileName: "",
      delImgFileName: "",
      newImgFileName: "",
      imgUploaded: false,
      imgDeleted: false,
      userType: "Owner"
    });
  }

  onImageSelected(event) {
    console.log(this.contactInfoForm.get("imgFileName").value);
    if (!this.hasImg) {
      this.newImg = event.target.files[0];
      console.log(this.newImg);
      let newImgFileName = uuidv4() + "_" + this.newImg.name;
      console.log(newImgFileName);
      this.contactInfoForm.patchValue({
        imgFileName: newImgFileName,
        imgUploaded: true,
        newImgFileName: newImgFileName,
      });
      this.hasImg = true;
    } else {
      console.error("Contact already has image");
    }
  }

  deleteImg() {
    this.hasImg = false;
    if (this.contactInfoForm.get("imgUploaded").value) {
      //img was uploaded but not saved - removes uploaded image on frontend
      this.newImg = null;
      this.contactInfoForm.patchValue({
        imgFileName: this.contactInfoData.ImgFileName,
        newImgFileName: "",
        imgUploaded: false,
      });
    } else {
      //the delete is for an image on the backend
      this.contactInfoForm.patchValue({
        imgFileName: "",
        delImgFileName: this.contactInfoData.ImgFileName,
        imgDeleted: true,
      });
    }
  }

  viewImage() {
    if (!this.contactInfoForm.get("imgUploaded").value) {
      this.contactInfoService
        .downloadProfileImage(this.contactInfoData.ImgFileName)
        .subscribe((response) => {
          let downloadedFile = new File(
            [response],
            this.contactInfoData.ImgFileName,
            {
              type: response.type,
            }
          );

          var fileExtension = this.contactInfoData.ImgFileName.substr(
            this.contactInfoData.ImgFileName.lastIndexOf(".") + 1
          );

          var contentType = Helper.GetContentType(fileExtension);

          var blob = new Blob([downloadedFile], {
            type: contentType,
          });

          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = this.contactInfoData.ImgFileName;
          document.body.appendChild(link);

          setTimeout(() => window.open(link.href), 500);
        });
    } else {
      console.log("image was recently uploaded: logic not implemented");

      var fileExtension = this.newImg.name.substr(
        this.newImg.name.lastIndexOf(".") + 1
      );
      var contentType = Helper.GetContentType(fileExtension);

      var blob = new Blob([this.newImg], {
        type: contentType,
      });

      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = this.newImg.name;
      document.body.appendChild(link);

      setTimeout(() => window.open(link.href), 500);
    }
  }

  loadCountries() {
    // Use the lookup service to get Countries and Codes
    this.lookupService
      .getLookupByTableAlias("country")
      .pipe(take(1))
      .subscribe((country) => {
        // console.log("Country: ", country);
        this.countries = country;
        
        // After countries are loaded, set the country form value
        const countryValue = this.contactInfoData?.Country;
        //console.log("Country value to set:", countryValue);
        
        if (countryValue && typeof countryValue === 'string') {
          this.contactInfoForm.patchValue({
            country: countryValue
          });
         // console.log("Country form value set successfully to:", this.contactInfoForm.get("country")?.value);
        }
      });
  }

  loadAgencyInfo() {
    console.log("User OID: ", this.user.oid);
    this.contactInfoService
      .getContactInfoById(this.user.oid)
      .subscribe((agencyInfo: any) => {
        console.log("Agency Info: ", agencyInfo);
        // this.agentId = agencyInfo.Agent_ID.toString();
        // this.agencyId = agencyInfo.Agency_ID.toString();
        this.contactInfoForm.patchValue({
          agentID: agencyInfo.Agent_ID.toString(),
        });
      });
  }
}
